"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./styles/CVCard.css");
require("./styles/ChatWithMe.css");
require("./styles/FriendList.css");
require("./styles/ProfileCard.css");
require("./styles/ProfileView.css");
require("./styles/QRCodeCard.css");
require("./styles/SocialCard.css");
require("./styles/StuffCard.css");
require("./styles/utilities.css");
var _litHtml = require("lit-html");
var _ProfileView2 = require("./ProfileView");
var _EditProfileView = _interopRequireDefault(require("./editProfilePane/EditProfileView"));
var _solidUi = require("solid-ui");
var qrcode = _interopRequireWildcard(require("qrcode"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
async function loadExtendedProfile(store, subject) {
  const otherProfiles = store.each(subject, _solidUi.ns.rdfs('seeAlso'), null, subject.doc());
  if (otherProfiles.length > 0) {
    await store.fetcher.load(otherProfiles);
  }
}
const Pane = {
  global: false,
  icon: _solidUi.icons.iconBase + 'noun_15059.svg',
  name: 'profile',
  label: function (subject, context) {
    const t = context.session.store.findTypeURIs(subject);
    if (t[_solidUi.ns.vcard('Individual').uri] || t[_solidUi.ns.foaf('Person').uri] || t[_solidUi.ns.schema('Person').uri]) {
      return 'Profile';
    }
    return null;
  },
  editor: _EditProfileView.default,
  render: (subject, context) => {
    const target = context.dom.createElement('div');
    const store = context.session.store;
    loadExtendedProfile(store, subject).then(async () => {
      (0, _litHtml.render)(await (0, _ProfileView2.ProfileView)(subject, context), target);
      const QRCodeEles = Array.from(target.getElementsByClassName('QRCode')); // was context.dom
      if (!QRCodeEles.length) return console.error('QRCode Ele missing');
      for (const QRCodeElement of QRCodeEles) {
        const value = QRCodeElement.getAttribute('data-value');
        if (!value) return console.error('QRCode data-value missing');
        const highlightColor = QRCodeElement.getAttribute('highlightColor') || '#000000';
        const backgroundColor = QRCodeElement.getAttribute('backgroundColor') || '#ffffff';
        // console.log(`@@ qrcodes2 colours highlightColor ${highlightColor}, backgroundColor ${backgroundColor}`)

        const options = {
          type: 'svg',
          color: {
            dark: highlightColor,
            light: backgroundColor
          }
        };
        qrcode.toString(value, options, function (error, svg) {
          if (error) {
            console.error('QRcode error!', error);
          } else {
            // console.log('QRcode success.', svg);
            QRCodeElement.innerHTML = svg;
            QRCodeElement.style.width = '80%';
            QRCodeElement.style.height = '80%';
            QRCodeElement.style.margin = '10%';
          }
        });
      }
    });
    return target;
  }
};
var _default = exports.default = Pane;